import React from "react";
import { motion } from "framer-motion";

const TeamGrid = ({
  heading,
  description,
  data
}) => {

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 35,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut",
      },
    },
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  return (
    <>
      <section className="our-team-section">

        <div className="container">

          {/* TOP CONTENT */}
          <motion.div
            className="our-team-top"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeUp}
          >

            <motion.h2
              className="section-heading"
              variants={fadeUp}
            >
              {heading}
            </motion.h2>

            <motion.p
              className="section-text"
              variants={fadeUp}
            >
              {description}
            </motion.p>

          </motion.div>

          {/* TEAM GRID */}
          <motion.div
            className={`our-team-grid ${
              data.length <= 3
                ? "our-team-grid-3"
                : "our-team-grid-6"
            }`}
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.15 }}
          >

            {data.map((item, index) => (
              <motion.div
                className="our-team-card"
                key={index}
                variants={fadeUp}
                whileHover={{
                  y: -10,
                  transition: { duration: 0.3 },
                }}
              >

                {/* IMAGE */}
                <div className="our-team-image-wrapper">

                  <motion.img
                    src={item.image}
                    alt={`${item.name} | Iris Impulse India Pvt. Ltd.`}
                    className="our-team-image"
                    whileHover={{
                      scale: 1.1,
                    }}
                    transition={{
                      duration: 0.4,
                    }}
                  />

                </div>

                {/* CONTENT CARD */}
                <motion.div
                  className="our-team-content"
                  variants={fadeUp}
                >

                  <h3 className="card-heading">
                    {item.name}
                  </h3>

                  <p className="section-text">
                    <strong>{item.role}</strong>
                  </p>

                  <p className="section-text">
                    {item.degree}
                  </p>

                  <p className="section-text">
                    {item.experience}
                  </p>

                </motion.div>

              </motion.div>
            ))}

          </motion.div>

        </div>

      </section>
    </>
  );
};

export default TeamGrid;